import { FeatureMouseInteraction } from '@openlayers/interaction/FeatureMouseInteraction';
import { ModelsLayer } from '@openlayers/models/ModelsLayer';
import Feature from 'ol/Feature';
import { Events } from '@shared/Events';


/**
 * @author NikolaV
 */
export class ModelOutlineDesktopMouseInteraction extends FeatureMouseInteraction<ModelsLayer> {

    onClick = (features: Feature[], e, n): void => {
        if (features[0]) {
            const data = features[0].get('data');
            data.id = features[0].get('source').modelId;
            Events.trigger('mapClickModel', data);
        }
    };
}
